import { connect } from "react-redux"
import styled , {css} from "styled-components"
import { setChoice } from "../../Redux/Game/gameActions"

const Button = styled.button`
    background-Color : #fff;
    box-sizing : border-box;
    border-radius : 50%;
    aspect-ratio : 1;
    display : flex;
    padding : 1rem;
    justify-content : center;
    align-items : center;
    z-index:20;
    ${
        props=>
        (props.variant === "paper" && css`
            border : 15px solid hsl(230, 89%, 62%);
        
        `) 
        ||
        (props.variant === "rock" && css`
            border : 15px solid hsl(349, 71%, 52%);
        
        `) 
        ||
        (props.variant === "scissors" && css`
            border : 15px solid hsl(39, 89%, 49%);
        
        `) 
    
    } ;
`




const Choice = (props) => {
  return (
    <div>
        <Button {...props} variant = {props.variant} onClick={()=>{
            props.selectChoice(props.variant)
        }}>
            {props.children}
        </Button>
    </div>
  )
}

const mapDispatchToProps = dispatch =>({

    selectChoice : choice=>dispatch(setChoice(choice))
})


export default connect(null,mapDispatchToProps)(Choice) 